import { render, staticRenderFns } from "./orderRiskTraceList.vue?vue&type=template&id=508e72c0&scoped=true"
import script from "./orderRiskTraceList.vue?vue&type=script&lang=js"
export * from "./orderRiskTraceList.vue?vue&type=script&lang=js"
import style0 from "./orderRiskTraceList.vue?vue&type=style&index=0&id=508e72c0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508e72c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/dev-node-01/workspace/test-flight/tinggo/tinggo-vue-12765/server_app_code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('508e72c0')) {
      api.createRecord('508e72c0', component.options)
    } else {
      api.reload('508e72c0', component.options)
    }
    module.hot.accept("./orderRiskTraceList.vue?vue&type=template&id=508e72c0&scoped=true", function () {
      api.rerender('508e72c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/page/risk/orderRiskTraceList.vue"
export default component.exports